export default __webpack_public_path__ + "static/media/icon-info.0a6fae40.svg";